<template>
  <div class="">
    <div class="ui four stackable cards" v-if="products.length > 0">
      <ProductItem
        v-for="product in products"
        :product="product"
        :isMatrix="isMatrix"
        v-on:addToCart="openOptions"
        v-on:showProductDetails="openProductDetails"
        :key="product._id"
      />

      <sui-modal v-model="open" size="tiny">
        <sui-modal-header>Agregar Producto</sui-modal-header>
        <sui-modal-content image>
          <sui-image wrapped size="small" :src="productImage" />
          <sui-modal-description>
            <sui-header>{{ tmpProduct.name }}</sui-header>
            <div class="ui form many-items">
              <table class="ui very basic compact table unstackable">
                <thead>
                  <tr>
                    <th class="one wide" scope="col">Talla</th>
                    <th class="one wide" scope="col">Existencia</th>
                    <th class="one wide" scope="col">Cantidad</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="stock in tmpProduct.stocks" :key="stock._id">
                    <td class="center aligned done wide">
                      {{ stock.attribute }}
                    </td>
                    <td class="center aligned one wide">
                      {{ stock.stock }}
                    </td>
                    <td class="two wide">
                      <vue-numeric-input
                        v-model="stock.quantity"
                        :min="0"
                        :max="stock.stock"
                        :step="1"
                        :precision="0"
                        size="100px"
                        align="center"
                      ></vue-numeric-input>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </sui-modal-description>
        </sui-modal-content>
        <sui-modal-actions>
          <sui-button @click="closeOptions" negative> Cancelar </sui-button>
          <sui-button @click="addProductToCart" positive> Agregar </sui-button>
        </sui-modal-actions>
      </sui-modal>
    </div>
    <div v-else class="">
      <h3 class="ui center aligned header">
        No hay productos para mostrar en esta categoría o búsqueda
      </h3>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import ProductItem from "./ProductItem";
import VueNumericInput from "vue-numeric-input";

export default {
  name: "ProductList",
  props: ["isMatrix"],
  created() {},
  computed: {
    products() {
      return this.$store.getters["products/getProducts"];
    },
    productImage: function () {
      return this.tmpProduct.images.length > 0
        ? this.tmpProduct.images[0].thumbnailUrl
        : this.tmpProduct.image;
    },
  },
  methods: {
    closeOptions: function () {
      this.open = !this.open;
    },
    openProductDetails: function (productId) {
      this.$router.push({
        name: "ProductDetails",
        params: { productId: productId },
      });
    },
    openOptions: async function (productId, price, wholesalePrice) {
      const cart = this.$store.getters["cart/getCart"];

      const product = await this.$store.dispatch("products/productById", productId);
      console.log("price" + price);
      console.log("wholesale" + wholesalePrice);
      this.tmpProduct = _.cloneDeep(product);

      this.tmpProduct.shopPrice = price;
      this.tmpProduct.shopWholesalePrice = wholesalePrice;

      this.tmpProduct.stocks = this.tmpProduct.stocks
        .filter((s) => s.stock > 0 && !cart.products.find((p) => p._id === s._id))
        .map((s) => {
          if (s.stock > 0) return { ...s, quantity: 0 };
        });
      this.open = !this.open;
    },
    addProductToCart: async function () {
      //map product into cart items

      const products = this.tmpProduct.stocks
        .filter((s) => s.quantity > 0)
        .map((s) => {
          const name =
            this.tmpProduct.name +
            " - " +
            this.tmpProduct.brands[0].name +
            " - " +
            (this.tmpProduct.color ? this.tmpProduct.color + " - T: " : "T: ") +
            s.attribute;
          return {
            productId: this.tmpProduct._id,
            attributeId: s._id,
            name: name,
            price: this.tmpProduct.price,
            wholesalePrice: this.tmpProduct.wholesalePrice,
            shopPrice: this.tmpProduct.shopPrice,
            shopWholesalePrice: this.tmpProduct.shopWholesalePrice,
            quantity: s.quantity,
            image:
              this.tmpProduct.images.length > 0
                ? this.tmpProduct.images[0].thumbnailUrl
                : this.tmpProduct.image,
            extended1: this.tmpProduct.extended1,
            extended2: this.tmpProduct.extended2,
          };
        });

      if (products && products.length > 0) {
        await this.$store.dispatch("cart/addProduct", { products: products });
      }

      this.open = !this.open;
    },
  },
  data() {
    return {
      open: false,
      tmpProduct: {
        name: "",
        brands: [],
        image: "",
        stocks: [],
        images: [],
      },
    };
  },
  components: {
    ProductItem,
    VueNumericInput,
  },
};
</script>
<style>
.products {
  background: #f7f8fb;
  padding: 30px 0;
}

.many-items {
  max-height: 400px;

  overflow-y: scroll;
  border: 2px inset rgba(110, 110, 110, 0.1);
  border-radius: 6px;
  padding: 20px;
}

.fixed_header thead tr {
  display: block;
}

@media only screen and (max-width: 800px) {
  .many-items {
    max-height: 280px;
    padding: 12px;
    overflow-y: scroll;
    border: 2px inset rgba(110, 110, 110, 0.27);
    border-radius: 6px;
  }
}
</style>
